import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import "./Spiritual_Dashboard.css";
import { useNavigate } from "react-router-dom";
import My_progress from "../../../common/modals/my-progress-modal/My_progress";

const Spiritual_Dashboard = () => {


  const [myProgress, setMyProgress] = useState(false);

  const navigate = useNavigate();



  const navs = [
    {
      label: "Notification / Message Center",
      img: "/assets/images/profile/spiritual_dashboard/img3.png",
      path: "/notification"
    },
    {
      label: "Volunteer / Seva Logbook",
      img: "/assets/images/profile/spiritual_dashboard/img4.png",
      path: "/seva-logbook"
    },
    {
      label: "Donation Tracker",
      img: "/assets/images/profile/spiritual_dashboard/img5.png",
      path: "/donation-tracker",
    },
  ]


  return (
    <div className="Spiritual_Dashboard">
      <div className="main_div">
        <div className="title_div">
          <p className="title_text">Spiritual Dashboard</p>

          <div className="inner_content">
            <div className="img_text_div" onClick={() => setMyProgress(true)}>
              <img
                src="/assets/images/profile/spiritual_dashboard/img1.png"
                className="inner_img zoom_in_out"
              />
              <p className="inner_text">My Progress</p>
            </div>

            <div className="img_text_div" onClick={() => navigate('/journey-within')}>
              <img
                src="/assets/images/profile/spiritual_dashboard/img2.png"
                className="inner_img img2 zoom_in_out"
              />
              <p className="inner_text">Journey Within</p>
            </div>
          </div>
        </div>

        <div className="tabs_holder">
          <Nav variant="pills" className="flex-column spiritual_sidebar_nav">
            {navs.map((item, index) => (
              <React.Fragment key={index}>
                <Nav.Item

                >
                  <Nav.Link
                    onClick={() => navigate(item.path)}

                    eventKey={item.label.toLowerCase().replace(/\s+/g, "-")}
                  >
                    <div className="pink_img_holder">
                      <img
                        className="pink_tab_icon"
                        src={process.env.PUBLIC_URL + item.img}
                        alt={item.label}
                      />
                    </div>
                    <span className="tab_text">{item.label}</span>
                  </Nav.Link>
                </Nav.Item>
              </React.Fragment>
            ))}
          </Nav>
        </div>
      </div>

      <My_progress
        show={myProgress}
        onHide={() => setMyProgress(false)}
        headtext={'My Progress'}
        successfultext={'Congratulations on Completing Level 1 of Your Journey to Divinity!'}
      />
    </div>
  );
};

export default Spiritual_Dashboard;
